<template>
  <v-snackbar
    v-model="notificationSnapbar"
    v-if="notification"
    absolute
    top
    right
    color="white"
    elevation="24"
  >
    <v-flex
      @click="
        $router.push(`./chat/${notification.sender.id}`);
        getNotificationSnapbar({ notification: null, state: false });
      "
      class="d-flex"
    >
      <v-avatar size="40" class="mr-2">
        <v-img :src="notification.sender.avatar" />
      </v-avatar>
      <div class="black--text">
        <h4>{{ notification.sender.name }}</h4>
        <p class="mb-0">
          {{ notification.text }}
        </p>
      </div>
    </v-flex>

    <template v-slot:action="{ attrs }">
      <v-btn
        x-small
        fab
        color="white"
        class="black--text"
        depressed
        v-bind="attrs"
        @click="getNotificationSnapbar({ notification: null, state: false })"
      >
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  methods: mapActions(['getNotificationSnapbar']),
  computed: mapGetters(['notification', 'notificationSnapbar'])
}
</script>
